import { Box as MuiBox, styled, Typography as MuiTypography } from '@material-ui/core';

export const Typography = styled(MuiTypography)({
  margin: '10px 6px',
});

export const Box = styled(MuiBox)({
  marginTop: '10px',
});
